// Dominio de los enlaces que se comparten (WhatsApp, catálogo, invitaciones,
// seguimiento). gestionnorgym.web.app sigue sirviendo la app, pero ningún enlace
// nuevo debe salir con él aunque el admin lo tenga abierto (o tenga instalada la
// PWA desde ahí). En localhost u otro host se conserva el origen actual.
export const ORIGEN_CANONICO = 'https://app.allgym.app';
const HOSTS_LEGADOS = new Set(['gestionnorgym.web.app', 'gestionnorgym.firebaseapp.com']);

export const esDominioLegado = (ubicacion = window.location) => HOSTS_LEGADOS.has(ubicacion.hostname);

export const origenPublico = (ubicacion = window.location) =>
  (esDominioLegado(ubicacion) ? ORIGEN_CANONICO : ubicacion.origin);
